import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Airport } from '../models/airport.model';
import { Country } from '../../business/models/country.model';
import { Fss } from '../models/fss.model';


@Injectable()
export class OverviewService {

  constructor(private _http: HttpClient,
              private _errorHandler: ErrorHandler) { }

  /**
   * updates specified entity via api
   * @param {number} airportID
   * @param {string} website
   * @return {Promise<any>}
   */
  putOverview(airportID: number, website: string): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/${airportID}`;
    try {
      return this._http.put(URL, { website: website }).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  putIslandAirport(airport: Airport): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/island/${airport.airportId}`;
    try {
      return this._http.put(URL, airport.serialize()).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  async getFsses(): Promise<Fss[]> {
    const URL = `${environment.airportsApiUrl}/airports/fsses`;
    try {
      const RESPONSE: any = await this._http.get(URL).toPromise();

      if (!RESPONSE) {
        this._errorHandler.handleError(new Error('API did not return valid fss Obj'));
      } else {
        return (RESPONSE || []).map(d => Fss.parse(d));
      }
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }
}
